import { useRoutes, NavigateFunction } from 'react-router-dom';
import routes from './config';

declare global {
  interface Window {
    REACT_APP_NAVIGATE: NavigateFunction | null;
  }
}

window.REACT_APP_NAVIGATE = null;

let navigateResolve: ((navigate: NavigateFunction) => void) | null = null;
export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolve = resolve;
});

export const AppRoutes = () => {
  const element = useRoutes(routes);
  return element;
};

export const setNavigate = (navigate: NavigateFunction) => {
  window.REACT_APP_NAVIGATE = navigate;
  if (navigateResolve) {
    navigateResolve(navigate);
  }
};
